<template>
  <div class="profile">
    <div class="container">
      <div class="profile__wrapper">
        <div class="profile__top">
          <div class="profile__top-left">
            <div class="profile__avatar">
              <input type="file" id="avatar" @change="handleFileUpload" />
              <label for="avatar">
                <img class="profile__avatar-image" v-if="userAvatar" :src="userAvatar" alt="">
                <img v-else src="@icons/avatarIcon.svg" alt="avatar" loading="lazy">
                <span class="profile__avatar-inner">
                  <svg width="87" viewBox="0 0 87 91" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M82.1045 37.2793H68.9791C58.2153 37.2793 49.4499 28.5138 49.4499 17.7501V4.62467C49.4499 2.12676 47.4062 0.0830078 44.9082 0.0830078H25.6516C11.6632 0.0830078 0.354492 9.16634 0.354492 25.3801V65.6193C0.354492 81.833 11.6632 90.9163 25.6516 90.9163H61.3491C75.3374 90.9163 86.6462 81.833 86.6462 65.6193V41.8209C86.6462 39.323 84.6024 37.2793 82.1045 37.2793ZM44.772 62.6672L35.6887 71.7505C35.3707 72.0684 34.962 72.3409 34.5532 72.4772C34.1445 72.6588 33.7357 72.7497 33.2816 72.7497C32.8274 72.7497 32.4187 72.6588 32.0099 72.4772C31.6466 72.3409 31.2832 72.0684 31.0107 71.7959C30.9653 71.7505 30.9199 71.7505 30.9199 71.7051L21.8366 62.6218C20.5195 61.3047 20.5195 59.1247 21.8366 57.8076C23.1537 56.4905 25.3337 56.4905 26.6507 57.8076L29.8753 61.123V42.0934C29.8753 40.2313 31.4195 38.6872 33.2816 38.6872C35.1437 38.6872 36.6878 40.2313 36.6878 42.0934V61.123L39.9578 57.853C41.2749 56.5359 43.4549 56.5359 44.772 57.853C46.0891 59.1701 46.0891 61.3501 44.772 62.6672Z"
                        fill="#3b3b3b"/>
                  <path d="M68.1595 31.0143C72.4741 31.0597 78.4691 31.0597 83.6012 31.0597C86.1899 31.0597 87.5524 28.0168 85.7357 26.2001C79.1957 19.6147 67.4783 7.76094 60.7566 1.03927C58.8945 -0.822814 55.6699 0.448853 55.6699 3.0376V18.888C55.6699 25.5189 61.3016 31.0143 68.1595 31.0143Z"
                        fill="#3b3b3b"/>
                </svg>
                </span>
              </label>
            </div>
            <div class="profile__top-info">
              <p>{{ userFirstName }} {{ userLastName }}</p>
              <p>{{ userEmail }}</p>
<!--              <div>-->
<!--                <span style="color: #3b3b3b">€</span>-->
<!--                <p>{{ userBalance }}</p>-->
<!--              </div>-->
            </div>
          </div>
          <ui-button class="profile__top-button" @click="logout">
            {{ t('buttons.logOut') }}
            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="28" viewBox="0 0 27 28" fill="none">
              <path d="M9.5625 6.125L17.4375 14L9.5625 21.875" stroke="#3b3b3b" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </ui-button>
        </div>
        <nav class="profile__nav">
<!--          <router-link-->
<!--              :to="translations.i18nRoute({ name: 'profile-balance' })"-->
<!--              class="profile__nav-item"-->
<!--              :class="[{ active: route.name === 'profile-balance' }]"-->
<!--          >-->
<!--            {{ t('profile.nav.topUp') }}-->
<!--          </router-link>-->
          <router-link
              :to="translations.i18nRoute({ name: 'profile-purchases' })"
              class="profile__nav-item"
              :class="[{ active: route.name === 'profile-purchases' }]"
          >
            {{ t('profile.nav.myPurchases') }}
          </router-link>
          <router-link
              :to="translations.i18nRoute({ name: 'profile-settings' })"
              class="profile__nav-item"
              :class="[{ active: route.name === 'profile-settings' }]"
          >
            {{ t('profile.nav.settings') }}
          </router-link>
        </nav>
        <div class="profile__main">
          <RouterView v-slot="{ Component }">
            <Transition name="opacity" mode="out-in">
              <component :is="Component" />
            </Transition>
          </RouterView>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {Auth} from "@/core/api/auth.js";
import {ElNotification} from "element-plus";
import {useAuthStore} from "@/stores/auth.js";
import {computed} from "vue";
import UiButton from "@/components/ui/ui-button.vue";
import {useI18n} from "vue-i18n";
import translations from "@/core/helpers/translations.js";
import {useRoute, useRouter} from "vue-router";

const {t} = useI18n()
const authStore = useAuthStore()
const route = useRoute()
const router = useRouter()

const userAvatar = computed(() => authStore.user?.avatar || '')
const userFirstName = computed(() => authStore.user?.firstName || '')
const userLastName = computed(() => authStore.user?.lastName || '')
const userEmail = computed(() => authStore.user?.email || '')
const userBalance = computed(() => authStore.user?.balance?.amount || 0)

const accessToken = computed(() => authStore.accessToken);

const handleFileUpload = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append('file', file);

  const response = await Auth.updateAvatar(formData, accessToken.value);
  const res = await response.json();

  if (res.errors) {
    ElNotification({
      title: t('popup.error'),
      message: res.errors[0].message,
      type: 'error'
    })
  } else {
    authStore.setUser({
      user: res.data.uploadAvatar.user,
      accessToken: accessToken.value
    })
  }
};

const logout = async () => {
  authStore.setUser({
    user: null,
    accessToken: null
  })

  localStorage.removeItem('digitgiftcode-refresh')

  await router.push({
    name: 'home',
    params: {
      locale: localStorage.getItem('digitgiftcode-user-locale') || 'en-gb'
    }
  })
}
</script>

<style lang="scss" scoped>
.profile {
  padding-top: 150px;

  &__top {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 25px;
    padding-bottom: 40px;

    &-left {
      display: flex;
      align-items: stretch;
      gap: 40px;
    }

    &-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      & p {
        color: #000000;
        font-size: 20px;
        font-weight: 600;
        line-height: 26px;
      }

      & div {
        border-radius: 27px;
        background-color: #F3F9FB;
        padding: 10px 20px;
        display: flex;
        align-items: center;
        gap: 10px;
        width: fit-content;

        color: #000000;
        font-size: 21px;
        font-weight: 500;
        line-height: 27px;
      }
    }

    &-button {
      width: fit-content;
      padding: 10px 20px;
    }
  }

  &__avatar {
    width: 150px;
    height: 150px;
    border-radius: 13px;
    background-color: #FFFFFF;
    border: 2px solid #3b3b3b;
    box-shadow: 0 0 9.1px 0 rgba(0, 0, 0, 0.20);
    position: relative;

    @include hover {
      .profile__avatar-inner {
        opacity: 1;
      }
    }

    & label {
      cursor: pointer;
      display: grid;
      place-items: center;
      height: 100%;
    }

    &-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 13px;
    }

    &-inner {
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
      inset: 0;
      border-radius: 13px;
      display: grid;
      place-items: center;
      opacity: 0;
      transition: 0.2s;
      background-color: rgba(0, 0, 0, 0.5);

      & svg {
        width: 60px;
      }
    }

    & input {
      display: none;
    }
  }

  &__nav {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 50px;
    border-bottom: 1px solid #1E1E1E;
    border-top: 1px solid #1E1E1E;

    &-item {
      height: 64px;
      display: grid;
      place-items: center;
      color: #000000;
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;

      @include hover {
        color: #3b3b3b;
      }

      &.active {
        border-bottom: 3px solid #3b3b3b;
        color: #3b3b3b;
      }
    }
  }
}

@media (max-width: 700px) {
  .profile {
    &__top {
      flex-direction: column;
      align-items: flex-start;
      gap: 25px;
    }
  }
}

@media (max-width: 500px) {
  .profile {
    &__top {
      align-items: center;
      gap: 10px;

      &-left {
        flex-direction: column;
        align-items: center;
        gap: 10px;
      }

      &-info {
        align-items: center;
        gap: 10px;
      }
    }

    &__nav {
      justify-content: center;
      gap: 20px;
    }
  }
}
</style>